module.exports = __webpack_public_path__ + "static/media/MEDAL_FR.d3048570.png";